import { type QueryHookOptions, useQuery } from "@apollo/client";
import { SupportRequestsDashboardQuery } from "../graphql/queries";
import type {
  SupportRequestsDashboardQueryType,
  SupportRequestsDashboardQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useSupportRequestsDashboardQuery = (
  options?: QueryHookOptions<
    SupportRequestsDashboardQueryType,
    SupportRequestsDashboardQueryVariablesType
  >
) =>
  useQuery<
    SupportRequestsDashboardQueryType,
    SupportRequestsDashboardQueryVariablesType
  >(SupportRequestsDashboardQuery, options);
